import { onMounted } from '@vue/composition-api';
import _ from 'lodash';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import store from '@/renderer/store';
import guideHandle from '@/renderer/views/desktop/FileManagement/Workbench/composition/guideHandler';
import userGuideInfoHandler from '@/renderer/views/composition/common/userGuideInfoHandler';

/**
 *  用于判断页面被刷新后是否需要重新弹窗
 *  1. 当前是超管
 *  2. 未留资询
 *  3. 已经weclome弹过窗
 */

const surveryHandler = () => {
  const {
    methods: { customeCreateNoviceGuidance },
  } = guideHandle();
  const { hasSurveyInfo, hasGuidance } = userGuideInfoHandler();
  const methods = {
    async init() {
      // orgChannel === 'official-free' 说明是官网免费版
      // 私有化直接return
      const { isPrivate, isMobile, editionFlag } = store.getters;
      if (isPrivate || isMobile) {
        return;
      }
      // 个人版不主动弹留资窗口
      if (editionFlag === 'personal') return;
      const { userRole, orgChannel } = user.getUserInfo();
      // 1. 判断是否是超管
      if (userRole !== RoleMap.SuperAdmin) return;
      const [hasGuidanceFlag, hasSurveyInfoFlag] = await Promise.all([hasGuidance(), hasSurveyInfo()]);
      // 免费版 & 且没有弹窗过 (直接开启邀请新用户) & 并且已留咨
      if (orgChannel === 'official-free' && !hasGuidanceFlag && hasSurveyInfoFlag) {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_INVITE_DIALOG, { showGuidePopup: true });
        // 更新后台数据，认为不再是新用户。
        customeCreateNoviceGuidance();
        return;
      }
      // 2. 判断是否已经弹过窗
      if (!hasGuidanceFlag) return;
      // 3. 判断是否留资
      if (hasSurveyInfoFlag) return;
      // 4. 弹窗留资
      ipc.emit(ipc.RENDERER_EVENTS_MAP.START_USER_SURVEY);
    },
  };
  onMounted(() => {
    methods.init();
  });
};
export default surveryHandler;
